"use client";

import {
	CommandEmpty,
	CommandGroup,
	CommandSeparator,
} from "@layer/ui/components";
import type { CommandGroupType } from "@layer/utils/lib/commands";
import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import { activeCommandsAtom } from "@/modules/command-bar/atoms/states/command-page-state";
import { CommandBarGroupItem } from "./command-bar-group-item";

type CommandBarGroupType = {
	handleCommand: (command: CommandGroupType) => void;
};

const CommandBarGroup = ({ handleCommand }: CommandBarGroupType) => {
	const commands = useAtomValue(activeCommandsAtom);
	const t = useTranslations("Navigation.command");

	if (!commands.length) {
		return <CommandEmpty>{t("noResults")}</CommandEmpty>;
	}

	return commands.map(({ id, items }, index) => {
		return (
			<div key={id}>
				{index > 0 && <CommandSeparator />}
				<CommandGroup heading={t(id)}>
					<CommandBarGroupItem
						commandsGroupItems={items!}
						handleCommand={handleCommand}
					/>
				</CommandGroup>
			</div>
		);
	});
};

export { CommandBarGroup };
